import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import renewalService from '../../../../../../services/Public/Renewal/PLS/plsRenewal.service';
import violationService from '../../../../../../services/Public/Renewal/PLS/violation.service';
import { useSelector } from 'react-redux';
import Information from '../../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../../Shared/InformationContent/PlsInformation';
import { getRenewalCodeViolationAnswers } from '../../../../../../services/Shared/codeTable.service';
import GenericViolations from '../../../../../Shared/Card/Violations';
import Issues from '../../../../../Shared/Card/Issues';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';

function Violations() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const push = useNavigate();
    const sectionId = 4;
    const renewalId = useSelector(x => x.currentApplicationId);
    const entityId = useSelector(x => x.userInfo.EntityId)

    const [formData, updateFormData] = useState({
        renewalId: renewalId,
        dateCrte: new Date(),
        entityId: entityId,
        id: 0,
        userCrte: "",
        yesAnswerExplanation: ""
    });

    useEffect(() => {
        setHasLoaded(false);
        renewalService.plsGetSection(renewalId, sectionId).then((response) => {
            violationService.getViolation(renewalId).then((data) => {
                if (data.data) {

                    updateFormData(data.data);
                }
                else {
                    getRenewalCodeViolationAnswers(5).then((questions) => {
                        updateFormData({ ...formData, answers: [...questions] })
                    })
                }
                setSectionData(response.data);
                setHasLoaded(true);
            })
        })

    }, [])

    const { StringType } = Schema.Types;
    const showAdditionalFields = formData?.answers?.findIndex(x => x.answer == true) >= 0;
    const [showFormErrors, setShowFormErrors] = useState(false);
    const model = Schema.Model({
        yesAnswerExplanation: StringType().when(() => {
            return showAdditionalFields ? StringType().isRequired('This field is required') : StringType();
        })
    });


    const handleSubmit = (val, event) => {
        setShowFormErrors(true)
        if (!sectionData.isUserEditable) {
            push(routes.filter(x => x.sectionId == (sectionId + 2))[0].route)
        }
        else {
            var validationObject = model.check(formData);
            for (const key in validationObject) {
                if (validationObject[key].hasError && (!key.includes("yesAnswerExplanation") || (showAdditionalFields && key.includes("yesAnswerExplanation")))) {
                    return;
                }

            }
            if (formData?.answers?.findIndex(x => x.answer !== true && x.answer !== false) >= 0) {//undefined check
                return;
            }
            violationService.postViolation(formData).then((response) => {
                if (response.data.id) {
                    push(routes.filter(x => x.sectionId == (sectionId + 2))[0].route)
                }

            })
        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div className="plsRenewalViolationsPage">
            <Container fluid>
                <strong>Professional Land Surveyor Renewal</strong>
                <h4 className="mb-3">Violations</h4>
                <Information content={GetRenewalInformationContent("violations")} />
                <br />{hasLoaded ?
                    <Form model={model} onSubmit={handleSubmit} onChange={updateFormData} fluid formValue={formData}>
                        <GenericViolations
                            showFormErrors={showFormErrors}
                            showAdditionalFields={showAdditionalFields}
                            hideSignature={true}

                            isReadOnly={!sectionData.isUserEditable}
                            sectionId={sectionId}
                            sectionDataId={sectionData.id}
                            parentTypeId={3}
                            credentialTypeId={5}
                        />
                        <br />
                        <Issues isUserEditable={true} type={3} sectionId={sectionData.id} />
                        <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/individual/plsRenewal/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    )
}
export default Violations;